import { render } from "./newProduct.vue?vue&type=template&id=5776d57d&scoped=true"
import script from "./newProduct.vue?vue&type=script&lang=js"
export * from "./newProduct.vue?vue&type=script&lang=js"

import "./newProduct.vue?vue&type=style&index=0&id=5776d57d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5776d57d"]])

export default __exports__